/**
 * md5
 */
import Vue from 'vue';
import md5 from 'js-md5'

Vue.prototype.$md5 = md5;



// WEBPACK FOOTER //
// ./src/assets/js/$md5.js